/**
 * @ngdoc directive
 * @name ce-app:matchChildrenHeightsDirective
 *
 * @description
 *
 *
 * @restrict A
 * */
import angular from 'angular';

/* @ngInject */
export default function EqualHeightsDirective($timeout) {
    function link($scope, $element) {
        $timeout(function () {
            var $children = $element.children(),
                currentMaxHeight = 0,
                numImagesLoaded = 0,
                $images = $element.find('img'),
                imageCount = $images.length;

            if (imageCount > 0) {
                angular.forEach($images, function (image) {
                    if (image.complete) {
                        numImagesLoaded++;
                    }
                });
            }

            if (numImagesLoaded === imageCount) {
                angular.forEach($children, function (child) {
                    var childHeight = jQuery(child).outerHeight();

                    if (childHeight > currentMaxHeight) {
                        currentMaxHeight = childHeight;
                    }
                });

                // set heights
                $children.css({height: currentMaxHeight + 'px'});
            }
        });
    }

    return {
        restrict: 'A',
        scope: {},
        link: link
    };
}
